const { fontFamily } = require('tailwindcss/defaultTheme');

module.exports = {
  purge: ['./src/**/*.html', './src/**/*.vue'],
  future: {
    removeDeprecatedGapUtilities: true
  },
  theme: {
    extend: {
      colors: {
        darkblue: '#0B4987',
        yellow: '#F1D325',
        lightblue: '#0397DD',
        eublue: '#039'
      },
      fontFamily: {
        sans: ['"Roboto Condensed"', ...fontFamily.sans],
        eurostile: ['"Eurostile LT Std"', ...fontFamily.sans]
      },
      fontSize: {
        base: ['0.9375rem', '20px']
      },
      spacing: {
        18: '4.5rem',
        'screen-2xl': '1440px'
      },
      screens: {
        '2xl': '1440px',
        '3xl': '1680px'
      }
    },
    customForms: theme => ({
      default: {
        input: {
          padding: `${theme('spacing.1')} ${theme('spacing.2')}`,
          borderRadius: theme('borderRadius.sm'),
          border: "1px solid theme('colors.gray.400')",
          backgroundColor: theme('colors.gray.100'),
          '&:focus': {
            boxShadow: undefined,
            border: "1px solid theme('colors.gray.500')",
            backgroundColor: theme('colors.gray.200')
          }
        }
      }
    })
  },
  variants: {},
  plugins: [require('@tailwindcss/custom-forms')]
};
